import { Component, OnDestroy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { cbEfileStatusForActive, cbEfileStatusForTest, submitText } from '@app/conf/dataConfigurations';
import { HttpChargeBackService } from '@app/Modules/Shared/Services/http-charge-back.service';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { MessageService } from 'primeng/api';
import { CbService } from '@app/Modules/chargeback/Services/cb.service';
import { GlobalAppService } from '@app/Modules/Shared/Services/global-app.service';
import { LanguageSelectionService } from '@app/Modules/Shared/Services/language-selection.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cb-status-column',
  templateUrl: './efile-status-column.component.html',
  styleUrls: ['./efile-status-column.component.scss']
})

export class EfileStatusColumnComponent implements AgRendererComponent, OnDestroy {

  params: any;
  statusDefault: boolean = false;
  statusError: boolean = false;
  statusReadyToSubmit: boolean = false;
  
  cbEfileStatus: any;
  statusValue: any;
  isEfileSubmitted: boolean = false;
  isEfileDeleted: boolean = false;
  isFileSubmittedOrDeleted: boolean = false;
  submitText: any;
  isGlobalUser: boolean = false;
  region: string = '';
  statusExtensiveError: boolean = false;
  statusText: string = '';
  constructor(
    private httpServ: HttpChargeBackService,
    private appServ: AppService,
    private messageService: MessageService,
    private CbServ: CbService,
    private globalAppService: GlobalAppService,
    private translateService: TranslateService,
    private languageService: LanguageSelectionService
  ) {
    this.cbEfileStatus = [ ...cbEfileStatusForActive, ...cbEfileStatusForTest ];
  }


  agInit(params: any) {
    this.isGlobalUser = this.appServ.isGlobalUser;
    this.region = this.globalAppService.getDefaultRegionString().toUpperCase();
    this.params = params;
    if (params.data && params.data.status) {
      this.status();
      switch (params.data.status) {
        case "1"://Validated
          if(this.params.data.errors && this.params.data.errors > 50){
            this.extensiveErrorsFound();
          }
          else{
            this.errorsFound();
          }
          break;
        case "4"://Ready to submit
          this.readyToSubmit();
          break;
        default:
          this.commonStyling();
      }
    }
    //below code changes status column text to 'deleted' after efile has been deleted clicking on contextmenu link.
    this.CbServ.getDeletedStatusText().subscribe(data => {
      if (data) {
        if(this.params.rowIndex === data.rowIndex){
          this.statusValue = 'dataConfigData.cbEfileStatusForActive.Deleted_key';
          this.isEfileDeleted = true;
          this.isFileSubmittedOrDeleted = true;
        }
      }
    })

    //below code changes status column text to 'submitted' after efile has been submitted clicking on contextmenu link.
    this.CbServ.getSubmitStatusText().subscribe(data => {
      if (data) {
        if (this.params.rowIndex === data.rowIndex) {
          this.statusValue = 'dataConfigData.cbEfileStatusForActive.Submitted_key';
          this.isEfileSubmitted = true;
          this.isFileSubmittedOrDeleted = true;
          this.CbServ.setSubmitContextMenu(true);
        }
      }
    });

    this.languageService.getlanguage().subscribe(language => {
      if(language){
        this.updateTranslatedValue(); 
      }      
    });
  }

  refresh(params: any): boolean {
    return false;
  }

  errorsFound() {
    this.statusError = true;
  }

  extensiveErrorsFound(){
    this.statusExtensiveError = true;
  }

  readyToSubmit() {
    this.statusReadyToSubmit = true;
  }

  commonStyling() {
    this.statusDefault = true;
  }

  submitEfile(){
    this.appServ.setLoadingStatus(true);
    let request = {
      "claimFileId": this.params.data.eFileID,
      "salesOrgId": this.params.data.salesOrgId,
      "isDeleted": false, //for submit this should be false for delete this should be true
      "eFileStatus": 5 //this is enum for "Submitted" status and should always be passed as 5 only, for delete this parameter can be skipped
    }; 
    this.httpServ.updateCBEfileStatus(request).subscribe(data => 
      {
        if(data){ 
          this.isEfileSubmitted = true;
          this.isFileSubmittedOrDeleted = true;
          this.statusValue = 'dataConfigData.cbEfileStatusForActive.Submitted_key';
          this.CbServ.setSubmitContextMenu(true);// this is to change 'readyToSubmit' context menu to 'submit' context menu
          this.CbServ.initiateFileSubmit(request);
        }
      },
      (e) => {
        this.messageService.add({ detail: 'An unexpected error occurred. Please try again.', summary: 'Error', severity: 'error' })
      },
      () => {
        this.appServ.setLoadingStatus(false);
      });    
  }

  status() {
    let status = this.cbEfileStatus.find((item) => {
      return item.value === this.params.data.status;
    });
    if(status.value === '4'){
      this.statusValue = submitText;
      this.updateTranslatedValue();
    }
    else{
      this.statusValue = status.label;
      this.updateTranslatedValue();
    }
    
  }

  updateTranslatedValue(){
    this.translateService.get([this.statusValue]).subscribe(translations =>{
      this.statusText = translations[this.statusValue];      
    });
  }

  showTitleMessage() {
    // if(this.statusText && this.statusText.length > 16){
    //   return true
    // } else {
    //   return false;
    // }  
    return false;
  }

  ngOnDestroy() {
    // Required for unsubscribing and destroying the component  
  }

}
